import {useQuery} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import useChatRestClient from '@/Api/ChatRestClient';

interface FeedbackStepRating {
  step: 'RATING';
  question: string;
  max_rating: number;
}

interface FeedbackReason {
  id: number;
  label: string;
}

interface FeedbackStepImprovements {
  step: 'IMPROVEMENTS';
  reasons: FeedbackReason[];
  comment_allowed: boolean;
  comment_max_length: number;
}

interface FeedbackStepMessage {
  step: 'THANK_YOU' | 'COMPLETED';
  message: string;
}

export type FeedbackStep =
  | FeedbackStepRating
  | FeedbackStepImprovements
  | FeedbackStepMessage;

interface FeedbackFormResponse {
  steps: FeedbackStep[];
}

export default function useGetStudentClassFeedbackForm(classType?: string) {
  const ChatRestClient = useChatRestClient();
  const normalizedClassType = (classType || '').trim().toLowerCase();
  const queryKey = normalizedClassType
    ? ['student-class-feedback-form', normalizedClassType]
    : ['student-class-feedback-form'];

  return useQuery<FeedbackFormResponse, Error>(
    queryKey,
    async () => {
      const token = await getLocalStorage('access_token');

      const options: any = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      };

      const url = normalizedClassType
        ? `tournament/v1/get_student_class_feedback_form?class_type=${encodeURIComponent(normalizedClassType)}`
        : 'tournament/v1/get_student_class_feedback_form';

      return ChatRestClient.get(url, options);
    },
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: 1,
      onError: error => {
        console.error('Failed to fetch feedback form:', error);
      },
    },
  );
}
